import { render, staticRenderFns } from "./ModalHeading.vue?vue&type=template&id=69967a10"
import script from "./ModalHeading.vue?vue&type=script&lang=js"
export * from "./ModalHeading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports